import React from "react";
import { useFeatureFlag } from "../hooks/useLaunchDarkly";

interface FeatureFlagGateProps {
  flagKey: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const FeatureFlagGate: React.FC<FeatureFlagGateProps> = ({
  flagKey,
  children,
  fallback = null,
}) => {
  const isEnabled = useFeatureFlag(flagKey, false);

  return isEnabled ? <>{children}</> : <>{fallback}</>;
};
